
import { useScrollReveal } from '../../../hooks/useScrollReveal';

export default function CTA() {
  const { ref, isVisible } = useScrollReveal(0.15);

  return (
    <section id="contact" className="relative py-36 px-6 bg-slate-950 overflow-hidden">
      {/* Background Visual */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/14abfd8a9875e03acb973805d06b1a76.jpg"
          alt="CTA background"
          className="w-full h-full object-cover object-top opacity-20"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-slate-950 via-slate-950/80 to-slate-950" />
      </div>

      {/* Glow Effect */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-teal-500/5 rounded-full blur-3xl" />

      <div ref={ref} className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Badge */}
        <div className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border border-teal-500/20 bg-teal-500/5 mb-10 transition-all duration-700 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          <i className="ri-calendar-check-line text-teal-400 text-sm"></i>
          <span className="text-teal-400 text-xs font-medium tracking-wider uppercase">Get Started Today</span>
        </div>

        {/* Headline */}
        <h2 className={`text-4xl md:text-5xl lg:text-7xl font-bold text-white mb-8 tracking-tight leading-tight transition-all duration-700 delay-100 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}>
          Ready to Build a System<br />That <span className="bg-gradient-to-r from-teal-400 to-teal-300 bg-clip-text text-transparent">Scales?</span>
        </h2>

        {/* Subtext */}
        <p className={`text-base md:text-lg text-gray-400 mb-14 max-w-2xl mx-auto font-light leading-relaxed transition-all duration-700 delay-200 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          Schedule a strategic AI infrastructure session with Palemia AI. Discover how structured automation can transform your operations.
        </p>

        {/* CTA Buttons */}
        <div className={`flex flex-col sm:flex-row items-center justify-center gap-4 transition-all duration-700 delay-300 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <a
            href="#contact"
            className="px-8 py-4 bg-teal-500 text-slate-950 font-semibold text-sm hover:bg-teal-400 transition-all duration-300 rounded-lg cursor-pointer whitespace-nowrap hover:shadow-lg hover:shadow-teal-500/20 hover:-translate-y-0.5"
          >
            Book Strategy Call
          </a>
          <a
            href="#framework"
            className="px-8 py-4 border border-gray-600 text-gray-300 font-medium text-sm hover:border-teal-500/50 hover:text-teal-400 transition-all duration-300 rounded-lg cursor-pointer whitespace-nowrap hover:-translate-y-0.5"
          >
            Download Framework Overview
          </a>
        </div>
      </div>
    </section>
  );
}
